module.exports = __webpack_public_path__ + "img/tk.0ace706d.png";